import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { CampaignService } from "../services/Campaign.service";
import {
  IGetVendorBilling,
  ICreateVendorBilling,
} from "@shared/lib/types/briefCampains";
import {
  BRIEF_CAMPAIGNS_LIST_QUERY_KEY,
  VENDOR_BILLING_QUERY_KEY,
} from "../contsants";

export function useCreateVendorBilling(briefId: string, influencerId: string) {
  const {
    mutate: createVendorBilling,
    isLoading: isCreating,
    isSuccess: isCreated,
  } = useMutation<{
    type: "Influencer" | "Agency";
    vendorBilling: ICreateVendorBilling;
    agencyId?: string;
    contact?: string;
  }>({
    mutationFn: async ({ type, vendorBilling, agencyId, contact }) => {
      return await CampaignService.createVendorBilling(
        type,
        vendorBilling,
        agencyId,
        contact
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },

    onSuccess: (c, _) => {
      c.invalidateQueries({
        queryKey: [...VENDOR_BILLING_QUERY_KEY(influencerId || "")],
      });
      c.invalidateQueries({
        queryKey: [...BRIEF_CAMPAIGNS_LIST_QUERY_KEY(briefId)],
      });
    },
    options: {},
  });

  return {
    createVendorBilling,
    isCreating,
    isCreated,
  };
}
